// Adapted from workers-sdk's local-explorer-ui ScrollableCodeBlock.
export function ScrollableCodeBlock({ content }: { content: string }) {
  return (
    <pre className="max-h-64 overflow-y-auto px-4 py-3 font-mono text-xs wrap-break-word whitespace-pre-wrap text-kumo-default">
      {content}
    </pre>
  );
}
